import { __assign } from "tslib";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import PaywallLayout from '../PaywallLayout';
import Button from '../../../../../Button';
import getBiDataForDeviationLink from '../../../../../Duperbrowse/DeviationLink/getBiDataForDeviationLink';
import { BiLink, BiEventType } from '../../../../../biLogger';
import Points from '../../../../../Icons/Points';
import { IconSize } from '../../../../../Icons/IconWrap';
import { normalizePremiumFolderData } from '../../../../../utils/normalizePremiumFolderData';
import { useFlag } from '../../../../../redux/flags/hooks';
import s from '../Paywall.scss';
var PremiumFolderPaywall = function (_a) {
    var deviation = _a.deviation, startFolderAccess = _a.startFolderAccess, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    var newCheckout = useFlag('new_checkout');
    var _b = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), folderId = _b.folderId, folderUrl = _b.folderUrl, pointPrice = _b.pointPrice, formattedDollarPrice = _b.formattedDollarPrice, subproductId = _b.subproductId;
    var onClick = function (e) {
        if (folderId) {
            startFolderAccess(folderId);
            e.preventDefault();
        }
    };
    return (React.createElement(PaywallLayout, { deviation: deviation, icon: React.createElement("div", { className: s['premium-folders-icon'] }), title: t('deviationview.paywall.artstage.premiumFolder.title'), text: deviation.isVideo ? (
        /* prettier-ignore */
        React.createElement(Trans, { i18nKey: "deviationview.paywall.artstage.premiumFolder.text.video" },
            "To watch, unlock its",
            React.createElement(BiLink, { className: s['folder-preview-button'], href: folderUrl }, "Premium Folder"),
            "and support the artist!")) : (
        /* prettier-ignore */
        React.createElement(Trans, { i18nKey: "deviationview.paywall.artstage.premiumFolder.text" },
            "To view, unlock its",
            React.createElement(BiLink, { className: s['folder-preview-button'], href: folderUrl }, "Premium Folder"),
            "and support the artist!")), button: React.createElement(Button, { view: "b18", height: "medium", fullWidth: false, onClick: newCheckout ? undefined : onClick, href: newCheckout && subproductId
                ? Url.checkoutLink(subproductId)
                : undefined, biData: __assign(__assign({}, getBiDataForDeviationLink(deviation)), { evid: BiEventType.GALLERY_PURCHASE, authorid: deviation.author.useridUuid, galleryid: folderId, points: pointPrice }) }, "Unlock for " + formattedDollarPrice + " / ",
            React.createElement(Points, { className: s['points-icon'], size: IconSize.TINY, disableDefaultColors: true }), "" + pointPrice), width: width, height: height }));
};
PremiumFolderPaywall.displayName = 'PremiumFolderPaywall';
export default PremiumFolderPaywall;
//# sourceMappingURL=PremiumFolderPaywall.js.map